import React, { useState, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import PropTypes from 'prop-types';

import { formatNormalizedRating } from '../../../_shared/helpers/tsHelpers';
import SellerInfo from '../SellerInfo';
import ReducerConstants from '../../../_shared/constants/reducers';

const propTypes = {
  dealer: PropTypes.objectOf(PropTypes.any),
  tradeId: PropTypes.number,
  chatCount: PropTypes.number
};

const defaultProps = {
  dealer: undefined,
  tradeId: null,
  chatCount: null
};

const SellerInfoContainer = ({
  chatCount,
  dealer,
  tradeId,
  badges,
  tradeState,
  isOMP,
  tradeDetails
}) => {
  const user = useSelector(
    state => state[ReducerConstants.AUTH]?.user,
    shallowEqual
  );
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [isCsu, setIsCsu] = useState(false);

  // Parse the Accepted Payments array from API into a string[]
  useEffect(() => {
    if (dealer.acceptedPayments && dealer.acceptedPayments.length) {
      const acceptedMethods = dealer.acceptedPayments.map(method => method.key);

      setPaymentMethods(acceptedMethods);
    }
  }, [dealer.acceptedPayments]);

  // User specific logic
  useEffect(() => {
    if (user?.superUserId && user?.superUserId !== user?.id) {
      setIsCsu(true);
    }
  }, [user]);

  return (
    <SellerInfo
      acceptedPayments={dealer.acceptedPayments}
      address={dealer.address}
      appraisedBy={dealer.appraisedBy}
      chatCount={chatCount}
      dealerId={dealer.id}
      isCsu={isCsu}
      network={dealer.network}
      paymentMethods={paymentMethods}
      rating={formatNormalizedRating(dealer.rating)}
      ratingsCount={dealer.ratingCount}
      tradeId={tradeId}
      badges={badges}
      tradeState={tradeState}
      isOMP={isOMP}
      tradeDetails={tradeDetails}
    />
  );
};

SellerInfoContainer.propTypes = propTypes;
SellerInfoContainer.defaultProps = defaultProps;

export default SellerInfoContainer;
